<!-- by 7527189 2 0 -->
<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card  :bordered="false">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper" v-if="false">
          <!-- 搜索区域 -->
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :span="6">
                <a-form-item label="关键词" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入产品名称、防伪名称、UDI名称" v-model="queryParam.dataParam"></a-input>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <!-- <JDate v-model:value="queryParam.createTime" /> -->
                  <a-range-picker v-model="noQueryParam.createTime" format="YYYY-MM-DD" :placeholder="['开始时间', '结束时间']"
                                  @change="onDateChange" @ok="onDateOk" />
                </a-form-item>
              </a-col>

              <a-col :span="6">
                <a-form-item label="批号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入批次号" v-model="queryParam.batchNumber"></a-input>
                </a-form-item>
              </a-col>

              <a-col>
                <a-button type="primary" @click="searchQuery">查询</a-button>
              </a-col>

            </a-row>
          </a-form>

        </div>
<!--        <a-button style="margin-left: 10px;margin-bottom: 10px" @click="add" type="primary" icon="plus">新增</a-button>-->
        <!-- table区域-begin -->
        <div>
          <a-table ref="picitable" size="middle" bordered rowKey="id" :columns="columns" :dataSource="dataSource"
                   :pagination="ipagination"  :scroll="{ x: true }"  :loading="loading"
                   @change="handleTableChange">
            <span slot="action" slot-scope="text, record">
              <a @click="todo('详情',record)">详情</a>
              <a-divider type="vertical" />
              <a v-if="record.status == 3" @click="todo('启用',record)">启用</a>
              <a-divider v-if="record.status == 3" type="vertical" />
              <a v-if="record.status == 3" @click="todo('拒绝',record)">拒绝</a>
<!--              <a-divider v-if="record.status == 1 && record.status == 1 " type="vertical" />-->
              <a v-if="record.status == 1" @click="todo('接收',record)">丢弃</a>
<!--              <a-divider v-if="record.status == 1 " type="vertical" />-->
            </span>

            <span slot="type" slot-scope="text, record">
              {{delimiter.find(x=>x.value == record.type).label}}
            </span>

            <span slot="status" slot-scope="text, record">
              {{record.status == 1 ? '启用' : ''}}
              {{record.status == 0 ? '停用' : ''}}
              {{record.status == 2 ? '关闭' : ''}}
              {{record.status == 3 ? '待启用' : ''}}
            </span>

            <span slot="endTime" slot-scope="text, record">
              {{record.endTime == null ? '永久有效' : record.endTime}}
            </span>

          </a-table>
        </div>
        <!-- table区域-end -->
      </a-card>
    </a-col>
  </a-row>
</template>
<script>
import ImportFileModal from '@/components/tools/ImportFileModal'
import { queryMaterialCategoryTreeList, collectModify, agreeAuthorize } from '@/api/api'
import { postAction, getFileAccessHttpUrl } from '@/api/manage'
import { getMpListShort } from '@/utils/util'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import JEllipsis from '@/components/jeecg/JEllipsis'
import JDate from '@/components/jeecg/JDate'
import Vue from 'vue'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { queryEnableDictItemsByCode } from '@api/identifierCode/identifierCode'

export default {
  name: 'MaterialList',
  mixins: [JeecgListMixin],
  components: {
    ImportFileModal,
    JEllipsis,
    JDate,
  },
  data () {
    return {
      delimiter:[],
      List: [],
      isUpload: false,
      headers: {
        'X-Access-Token': Vue.ls.get(ACCESS_TOKEN),
        tenantId: this.$store.getters.tenantId,
      },
      categoryTree: [],
      mPropertyListShort: '',
      model: {},
      labelCol: {
        span: 3,
      },
      wrapperCol: {
        span: 18,
        offset: 1,
      },
      // 查询条件
      queryParam: {
        dataParam: '',
        batchNumber: '',
      },
      noQueryParam:{
        createTime: '',
      },
      ipagination: {
        pageSizeOptions: ['10', '20', '30', '50', '100', '200'],
      },
      // 实际表头
      columns: [],
      // 初始化设置的表头
      settingColumns: [
        'number',
        'type',
        'licenseeName',
        'content',
        'startTime',
        'endTime',
        'status',
        'createBy',
        'remark',
        'action',
        'authorizeName'
      ],
      // 默认的列
      defColumns: [
        { title: '授权编号', dataIndex: 'number', ellipsis: true },
        { title: '授权类型', dataIndex: 'type', scopedSlots: { customRender: 'type' }  },
        { title: '授权方', dataIndex: 'authorizeName',  },
        { title: '授权条数', dataIndex: 'content', },
        { title: '授权时间', dataIndex: 'startTime', },
        { title: '授权有效期', dataIndex: 'endTime',scopedSlots: { customRender: 'endTime' } },
        { title: '状态', dataIndex: 'status',  scopedSlots: { customRender: 'status' } },
        { title: '操作人', dataIndex: 'createBy',  },
        // { title: '备注', dataIndex: 'remark',  },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/authorize/receiveAuthorizeList',
        delete: '/material/delete',
        deleteBatch: '/material/deleteBatch',
        importExcelUrl: '/material/importExcel',
        exportXlsUrl: '/material/exportExcel',
        batchSetStatusUrl: '/material/batchSetStatus',
        batchSetMaterialCurrentStockUrl: '/material/batchSetMaterialCurrentStock',
      },
    }
  },
  created () {
    this.initColumnsSetting()
    queryEnableDictItemsByCode({code: 'authorize_type'})
      .then(res => {
        this.delimiter = res
      })
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}${this.url.importExcelUrl}`
    },
  },
  methods: {
    todo(type,row){
      let status = 0
      if(type=='详情') {
        this.$emit('detail',row)
        return false
      }else if(type=='启用'){
        status = 1
      }else if(type == '拒绝'){
        status = 2
      }else if(type == '丢弃'){
        status = 2
      }
      let that = this
      // this.$confirm({
      //   title: "确认操作",
      //   content: "确认操作?",
      //   onOk: function () {
      //     agreeAuthorize({
      //       id:row.id,
      //       status
      //     }).then(res=>{

      //       that.$message.success('操作成功')
      //       that.loadData(1)
      //     })
      //   }
      // })
      this.$confirm('确认操作', '确认操作', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(() => {
        agreeAuthorize({
          id:row.id,
          status
        }).then(res=>{

          that.$message.success('操作成功')
          that.loadData(1)
        })
      }).catch(() => {});
    },
    add(){
      this.$emit('add')
    },

    // 明细
    async details (record) {
      this.$refs.detailModel.show(record)
      this.$refs.detailModel.title = '批次采集明细'
    },

    onDateOk () { },
    onDateChange: function (value, dateString) {
      this.queryParam.beginTime = dateString[0]
      this.queryParam.endTime = dateString[1]
    },
    fatherMethod () {
      this.loadData(1)
    },
    Warehousing (record) {
      this.uploadfile(record)
    },
    ModifyCollectData(record){
      let that = this
      collectModify({id: record}).then((res)=>{
        if(res && res.code===200) {
          this.$message.info('重新采集成功！')
          that.loadData()
        } else {
          console.log(res.data)
          this.$message.warning('重新采集失败！'+res.msg)
        }
      });
    },
    uploadfile: function (e) {
      // this.$refs.UploadModel.edit()
      this.$refs.UploadModel.show(e)
      this.$refs.UploadModel.title = '仓库'
    },

    UploadModelOk () { },
    //加载初始化列
    initColumnsSetting () {
      let columnsStr = Vue.ls.get('picitable')
      if (columnsStr && columnsStr.indexOf(',') > -1) {
        this.settingColumns = columnsStr.split(',')
      }
      this.columns = this.defColumns.filter((item) => {
        if (this.settingColumns.includes(item.dataIndex)) {
          return true
        }
        return false
      })
      console.log(this.columns, ' this.columns')
    },

    loadTreeData () {
      let that = this
      let params = {}
      params.id = ''
      queryMaterialCategoryTreeList(params).then((res) => {
        if (res) {
          that.categoryTree = []
          for (let i = 0; i < res.length; i++) {
            let temp = res[i]
            that.categoryTree.push(temp)
          }
        }
      })
    },
    batchSetMaterialCurrentStock () {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！')
      } else {
        let ids = ''
        for (let a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ','
        }
        let that = this

        this.$confirm('是否操作选中数据?', '确认操作', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(() => {
          that.loading = true
            postAction(that.url.batchSetMaterialCurrentStockUrl, { ids: ids })
              .then((res) => {
                if (res.code === 200) {
                  that.$message.info('修正库存成功！')
                  that.loadData()
                  that.onClearSelected()
                } else {
                  that.$message.warning(res.data.message)
                }
              })
              .finally(() => {
                that.loading = false
              })
        }).catch(() => {});

      }
    },
    batchEdit () {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！')
      } else {
        let ids = ''
        for (let a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ','
        }
        this.$refs.batchSetInfoModalForm.edit(ids)
        this.$refs.batchSetInfoModalForm.title = '批量编辑'
      }
    },
    handleEdit: function (record) {
      this.$refs.modalForm.edit(record)
      this.$refs.modalForm.title = '编辑'
      this.$refs.modalForm.disableSubmit = false
      if (this.btnEnableList.indexOf(1) === -1) {
        this.$refs.modalForm.isReadOnly = true
      }
    },
    getImgUrl (imgName) {
      if (imgName && imgName.split(',')) {
        return getFileAccessHttpUrl('systemConfig/static/' + imgName.split(',')[0])
      } else {
        return ''
      }
    },
    handleImportXls () {
      let importExcelUrl = this.url.importExcelUrl
      let templateUrl = '/doc/goods_template.xls'
      let templateName = '商品Excel模板[下载]'
      this.$refs.modalImportForm.initModal(importExcelUrl, templateUrl, templateName)
      this.$refs.modalImportForm.title = '商品导入'
    },
    searchReset () {
      this.queryParam = {
        mpList: getMpListShort(Vue.ls.get('materialPropertyList')), //扩展属性
      }
      this.loadData(1)
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
